export const useDummyDigestItems = false;

export const flowDigestItems = [
    {
        sku: "SPGC2323",
        name: "Spotify Gift Card (RM50)",
        quantity: 3,
        unit_price: 50,
        amount: 150,
        tax_code: "SV6",
        tax_amount: 9,
    },
    {
        sku: "STGC2323",
        name: "Steam Gift Card (RM50)",
        quantity: 4,
        unit_price: 50,
        amount: 200,
        tax_code: "SV6",
        tax_amount: 12,
    },

];

export const flowDigestItemsPagination = {
    total: 3,
    current_page: 1,
    per_page: 10,
};
